import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientProfileCollaborators from "./client-profile-collaborators.vue";
import CollaboratorsDropdown from "./collaborators-dropdown.vue";
import BackButton from "@Shared/components/general/back-button";
import VueContentLoading from "vue-content-loading";
import Badge from "@Shared/components/general/badge.vue";
import { Fragment } from "vue-fragment";
import { DELETE_CLIENT_PROFILE, TOGGLE_COLLABORATOR_EMAIL_SYNC, REMOVE_PROFILE_COLLABORATOR, UPDATE_BOARD_CLIENTS, TRANSFER_CLIENT_PROFILE } from "@Broker/@Modules/clients/board/store/board-actions";
import { mapActions } from "vuex";
import Err from "../../../../../routes/error";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import { showToast } from "../../../../../../../shared/utils/constants";
import ClientProfileHeaderActionButton from "./profile-header/client-profile-header-action-button.vue";
import Icon from "@Shared/components/general/fa-icon.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileHeader",
  components: {
    CollaboratorsDropdown,
    VueContentLoading,
    ClientProfileCollaborators,
    BackButton,
    ProfileAvatar,
    Fragment,
    Badge,
    ClientProfileHeaderActionButton,
    Icon
  },
  props: {
    back: {
      type: String,
      default: ""
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    selectedBoardId: {
      type: String,
      default: ""
    },
    boards: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    saving: Boolean,
    silentLoading: Boolean
  },
  data() {
    return {
      actionButtonLoadingState: {
        loading: false,
        loadingSucceeded: true
      },
      disableDropdown: false
    };
  },
  computed: {
    details() {
      return this.profile || {};
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [DELETE_CLIENT_PROFILE, TOGGLE_COLLABORATOR_EMAIL_SYNC, REMOVE_PROFILE_COLLABORATOR, UPDATE_BOARD_CLIENTS, TRANSFER_CLIENT_PROFILE])), {}, {
    async updateEmailSync(collaborator = null) {
      if (!collaborator) {
        collaborator = {
          isCurrentUser: true,
          collaborationId: 0,
          enabled: this.details.trackEmails
        };
      }
      await this.TOGGLE_COLLABORATOR_EMAIL_SYNC(_objectSpread(_objectSpread({}, collaborator), {}, {
        id: this.clientProfileId
      }));
      this.$emit("changelog");
    },
    async deleteProfile() {
      const button = $(this.$refs.deleteProfileButton);
      try {
        button.animateButton().animate("start");
        await this.DELETE_CLIENT_PROFILE({
          id: this.clientProfileId
        });
        await button.animateButton().animate("finish");
        this.$router.replace({
          name: "boards"
        });
        $(this.$refs.deleteProfileModal).modal("hide");
        this.$destroy();
      } catch (e) {
        button.animateButton().animate("finish", "failed");
        Err.handle(e, {
          id: this.clientProfileId
        });
      }
    },
    getCalculatorsUrl() {
      return ` ${this.$options.filters.portalDomain("client", true)}#/calculations`;
    },
    handleChangeOwnership() {
      this.$emit("changelog");
    },
    handleAddRemoveCollaborator() {
      this.$emit("changelog");
    },
    async handleBoardSelect(boardId) {
      this.actionButtonLoadingState.loading = true;
      this.$refs.clientProfileHeaderActionButton.hide();
      try {
        const {
          statusLabelId
        } = this.profile;
        const {
          clientProfileId: id
        } = this;
        this.UPDATE_BOARD_CLIENTS({
          currentBoard: this.boardId,
          boardId
        });
        await this.TRANSFER_CLIENT_PROFILE({
          id,
          statusLabelId,
          boardId,
          inactive: false
        });
        showToast("success", "clientProfileMoved");
        this.actionButtonLoadingState.loadingSucceeded = true;
      } catch (e) {
        this.actionButtonLoadingState.loadingSucceeded = false;
      } finally {
        this.actionButtonLoadingState.loading = false;
      }
    }
  })
});